import React, { useRef } from 'react';
import ConditionalRenderer, { If } from '@components/ConditionalRenderer';
import { usePopoverSlide } from '@hooks/usePopoverSlide';
import { Checkbox } from 'antd';
import { Link } from 'react-router-dom';
import Icon from '@components/Icon';
import Logo from '@components/Logo';
import './style.scss';

const Modal = ({
  classNames, isVisible, size, icon, title, titleSm, subtitle, desc, links,
  closeModal, body, popover, mobileHeader, button, heading, action,
}) => {
  const handleClick = (e) => {
    if (!e.target.closest('.modal__content, .modal-dropdown')) {
      closeModal();
    }
  };

  const popoverRef = useRef(null);
  usePopoverSlide(popoverRef, closeModal);

  return (
    <div className={`${classNames || ''} modal modal_${size} ${isVisible ? 'open' : ''}`} onClick={handleClick}>
      <div className='modal__wrapper'>
        <div className={`modal__body ${popover ? 'popover-wrap' : ''}`}>
          <div className={`modal__content main-radius text-center ${popover ? 'popover' : ''}`} ref={popover ? popoverRef : null}>
            <div className='modal__close' onClick={closeModal}>
              <Icon type='close' />
            </div>

            <ConditionalRenderer condition={mobileHeader}>
              <If>
                <div className='modal__header dn show-sm'>
                  <Logo coreElement onClick={closeModal} />
                </div>
              </If>
            </ConditionalRenderer>
            <ConditionalRenderer condition={icon}>
              <If>
                <div className='modal__icon modal__icon_spaced'>
                  <img src={icon} alt='' />
                </div>
              </If>
            </ConditionalRenderer>
            <ConditionalRenderer condition={title}>
              <If>
                <div className='modal__title title-xl tablet-title-xl mobile-title-xl'>
                  {title}
                </div>
              </If>
            </ConditionalRenderer>
            <ConditionalRenderer condition={titleSm}>
              <If>
                <div className='modal__title title-xs tablet-title-xs mobile-title-xs'>
                  {titleSm}
                </div>
              </If>
            </ConditionalRenderer>
            <ConditionalRenderer condition={subtitle}>
              <If>
                <div className='modal__subtitle text-lg tablet-text-xl mobile-text-lg'>
                  {subtitle}
                </div>
              </If>
            </ConditionalRenderer>
            <ConditionalRenderer condition={desc}>
              <If>
                <div className='modal__desc text-lg tablet-text-lg mobile-text-lg'>
                  {desc}
                </div>
              </If>
            </ConditionalRenderer>
            <ConditionalRenderer condition={links}>
              <If>
                <div className='modal__links'>
                  {links?.map((link, index) => (
                    <Link key={index} to={link.url} className='modal__link field-text tablet-field-text mobile-field-text'>{link.title}</Link>
                  ))}
                </div>
              </If>
            </ConditionalRenderer>
            <ConditionalRenderer condition={action}>
              <If>
                <div className='modal__action'>
                  {action}
                </div>
              </If>
            </ConditionalRenderer>
            <ConditionalRenderer condition={button}>
              <If>
                <div className='modal__btn'>
                  {button}
                </div>
              </If>
            </ConditionalRenderer>
            <ConditionalRenderer condition={heading}>
              <If>
                {heading}
              </If>
            </ConditionalRenderer>
            <ConditionalRenderer condition={body}>
              <If>
                {body}
              </If>
            </ConditionalRenderer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
